import {Component, OnInit} from '@angular/core';
import {UserService} from "../service/user.service";
import {UserListItemInfo} from "../model/user-list-item-info";
import {MessageService} from "../service/message.service";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  users: UserListItemInfo[] = [];

  constructor(private userService: UserService, private messageService: MessageService) {
  }

  ngOnInit() {
    this.refreshUsers();
  }

  private refreshUsers() {
    this.userService.getUsers().subscribe(value => this.users = value, this.onRejected());
  }

  onDeleteUser(user: UserListItemInfo) {
    if (confirm("Do you want to delete this user?")) {
      this.userService.deleteUser(user.id).then(() => this.refreshUsers()).catch(this.onRejected());
    }
  }

  private onRejected() {
    return err => {
      this.messageService.addError('error occurred', err);
      console.log(err);
    }
  }

  countPremiumUsers(users: UserListItemInfo[]): number {
    return users.filter(u => u.premium).length;
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/users/users.component.ts